<template>
    <div>
        <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Student Fees Structure Import</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" align="center">
                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete :items="ay_list" v-model="ay" item-text="ay" item-value="id" label="Academic Year"
                        dense rounded hide-details outlined placeholder="Select Academic Year"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-btn :color="!ay ? 'grey lighten-1' : 'brand'" @click="downloadTemplate" :loading="excelloading"
                        :disabled="!ay" elevation="2" rounded>
                        <v-icon left>mdi-download</v-icon>
                        Download Excel Template
                    </v-btn>
                </v-col>
            </v-row>
            <br />
            <v-row justify="center" align="center" v-if="ay != null">
                <v-col cols="12" sm="4" md="4">
                    <v-file-input placeholder="CSV of student fee structure data" prepend-icon="mdi-file"
                        label="Student Fees Structure" show-size outlined rounded dense v-model="file"></v-file-input>
                </v-col>

            </v-row>
            <v-row justify="center" align="center">
                <v-btn class="button" @click="submitFile" :loading="output_load">Submit</v-btn>
            </v-row>
            <v-divider class="mt-4"></v-divider>

            <v-expand-transition>
                <div v-if="statuslist.length" class="result-area pa-6 grey lighten-5">
                    <div class="d-flex align-center mb-4">
                        <div class="text-h6 font-weight-bold grey--text text--darken-3">Import Summary</div>
                        <v-spacer></v-spacer>
                        <v-chip outlined small color="grey darken-1">Generated at {{ new Date().toLocaleTimeString()
                        }}</v-chip>
                    </div>

                    <v-row dense>
                        <v-col cols="12" md="4">
                            <v-card flat class="stat-card total-border">
                                <v-list-item three-line>
                                    <v-list-item-content>
                                        <div class="text-overline mb-1">Total Processed</div>
                                        <v-list-item-title class="text-h4 font-weight-black">{{ statuslist.length
                                        }}</v-list-item-title>
                                    </v-list-item-content>
                                    <v-avatar color="blue lighten-5" size="48">
                                        <v-icon color="blue">mdi-file-document-multiple-outline</v-icon>
                                    </v-avatar>
                                </v-list-item>
                            </v-card>
                        </v-col>

                        <v-col cols="12" md="4">
                            <v-card flat class="stat-card success-border">
                                <v-list-item three-line>
                                    <v-list-item-content>
                                        <div class="text-overline mb-1">Successful Imports</div>
                                        <v-list-item-title class="text-h4 font-weight-black green--text text--darken-2">
                                            {{ successCount }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    <v-avatar color="green lighten-5" size="48">
                                        <v-icon color="green">mdi-check-circle-outline</v-icon>
                                    </v-avatar>
                                </v-list-item>
                            </v-card>
                        </v-col>

                        <v-col cols="12" md="4">
                            <v-card flat class="stat-card fail-border">
                                <v-list-item three-line>
                                    <v-list-item-content>
                                        <div class="text-overline mb-1">Failed Records</div>
                                        <v-list-item-title class="text-h4 font-weight-black red--text text--darken-2">
                                            {{ failCount }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    <v-avatar color="red lighten-5" size="48">
                                        <v-icon color="red">mdi-alert-circle-outline</v-icon>
                                    </v-avatar>
                                </v-list-item>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-card flat class="mt-6 border-standard overflow-hidden">
                        <v-data-table :headers="header" :items="statuslist" :items-per-page="10" class="modern-table"
                            fixed-header show-expand item-key="Sr">
                            <template v-slot:item.Status="{ item }">
                                <v-chip small label depressed
                                    :color="item.Status === 'Success' ? 'green lighten-5 green--text text--darken-3' : 'red lighten-5 red--text text--darken-3'"
                                    class="font-weight-bold">
                                    <v-icon left x-small>{{ item.Status === 'Success' ? 'mdi-check' : 'mdi-close'
                                    }}</v-icon>
                                    {{ item.Status }}
                                </v-chip>
                            </template>

                            <template v-slot:item.Reason="{ item }">
                                <span class="grey--text text--darken-2">{{ item.Reason || '—' }}</span>
                            </template>
                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">

                                    <v-card class="mt-2 elevation-1 rounded-lg">
                                        <v-simple-table dense class="component-table">

                                            <thead>
                                                <tr>
                                                    <th class="text-left">Component</th>
                                                    <th class="text-right">Amount</th>
                                                    <th class="text-center">Status</th>
                                                    <th class="text-left">Reason</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr v-for="(c, index) in item.components" :key="index">

                                                    <td class="font-weight-medium">
                                                        {{ c.Name }}
                                                    </td>

                                                    <td class="text-right font-weight-medium">
                                                        ₹ {{ c.Amount }}
                                                    </td>

                                                    <td class="text-center">
                                                        <v-chip x-small label :color="c.Status === 'Success'
                                                            ? 'green lighten-5 green--text text--darken-2'
                                                            : 'red lighten-5 red--text text--darken-2'">
                                                            {{ c.Status }}
                                                        </v-chip>
                                                    </td>

                                                    <td class="grey--text text--darken-1">
                                                        {{ c.Reason }}
                                                    </td>

                                                </tr>
                                            </tbody>

                                        </v-simple-table>
                                    </v-card>

                                </td>
                            </template>
                        </v-data-table>
                    </v-card>
                </div>
            </v-expand-transition>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
import * as XLSX from 'xlsx';
export default {
    components: {
        Breadcrumbs,
    },

    /*
        Defines the data used by the component
      */
    data() {
        return {
            isallowed: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            file: null,
            load: false,
            loading3: false,
            search: "",
            ay_list: null,
            ay: null,
            output_load: false,
            statuslist: [],
            header: [
                { text: 'Row No.', value: 'Sr', width: '80px' },
                { text: 'Student PRN', value: 'PRN', width: '150px' },
                { text: 'Status', value: 'Status', width: '130px' },
                { text: 'Reason', value: 'Reason' }
            ],
            componentHeader: [
                { text: 'Component Name', value: 'Name', width: '80px' },
                { text: 'Amount', value: 'Amount', width: '150px' },
                { text: 'Status', value: 'Status', width: '130px' },
                { text: 'Reason', value: 'Reason' },
                { text: "", value: "data-table-expand" },
            ],
        };
    },
    mounted() {
        axios
            .post("/dataMigration/getAyList")
            .then((res) => {
                this.ay_list = res.data.ay_list;
            })
            .catch((error) => {
                this.showSnackbar("#b71c1c", "Something went wrong...");
            })
            .finally(() => { });
    },
    methods: {
        downloadTemplate() {
            // Create header row
            let header = ["Student PRN", "Fees Component Name"];

            const data = [header];

            // Create worksheet
            const ws = XLSX.utils.aoa_to_sheet(data);

            // Create workbook
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "ImportStudentFeesStructure");

            // Download file
            XLSX.writeFile(wb, `ImportStudentFeesStructure.xlsx`);
        },

        submitFile() {
            if (this.file == null) {
                alert("Please select the file!");
            } else {
                this.output_load = true;
                this.statuslist = [];
                let formData = new FormData();
                //console.log(this.file.size)
                formData.append("file", this.file);
                formData.append("ay", this.ay);


                //console.log(formData)
                axios
                    .post("dataMigration/importStudentFeesStructure", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((res) => {
                        if (res.data.statuslist) {
                            this.statuslist = res.data.statuslist;
                            this.load = true;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                            this.overlay = false;
                        }
                    })
                    .catch(function () {
                        console.log("FAILURE!!");
                    })
                    .finally(() => {
                        this.output_load = false;
                    });
                //     }
            }
        }, //end of the fuction
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        /*
            Handles a change on the file upload
          */
    },
    computed: {
        successCount() {
            return this.statuslist.filter(i => i.Status == "Success").length
        },
        failCount() {
            return this.statuslist.filter(i => i.Status == "Failed").length
        }
    }
};
</script>
<style scoped>
.downbtn {
    float: right;
}

/* new css */
table,
th {
    padding: 10px;
    border: 1px solid black;
    border-collapse: collapse;
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.mandatory {
    color: red;
}

.result-area {
    border-top: 1px solid #e0e0e0;
}

/* Stat Cards */
.stat-card {
    border: 1px solid #e0e0e0 !important;
    transition: all 0.3s ease;
    border-radius: 12px !important;
}

.stat-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05) !important;
}

.total-border {
    border-left: 6px solid #2196F3 !important;
}

.success-border {
    border-left: 6px solid #4CAF50 !important;
}

.fail-border {
    border-left: 6px solid #F44336 !important;
}

/* Table Styling */
.border-standard {
    border: 1px solid #e0e0e0 !important;
    border-radius: 12px !important;
}

.modern-table>>>thead th {
    background-color: #ffffff !important;
    height: 56px !important;
    color: #757575 !important;
    font-size: 0.8rem !important;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    border-bottom: 2px solid #f5f5f5 !important;
}

.modern-table>>>tbody tr:hover {
    background-color: #fcfdfe !important;
}

.modern-table>>>tbody td {
    height: 60px !important;
    border-bottom: 1px solid #f0f0f0 !important;
}

.component-table thead {
    background: #f5f7fb;
    font-weight: 600;
}

.component-table th {
    font-size: 13px;
    letter-spacing: 1px;
    text-transform: uppercase;
}

.component-table td {
    font-size: 14px;
}

.component-table tbody tr:nth-child(even) {
    background: #fafafa;
}
</style>
